$(function () {
    $('.js-open-legend').on('click', function () {
        $('.legend').toggleClass('legend-active')
        $('.legend').toggleClass('active-top')

        if ($('.hidden-block').hasClass('hidden-block-active')) {
            $('.hidden-block').removeClass('hidden-block-active');
            $('.js-close-view-nav').addClass('visible-print');
            $('.js-open-view-nav').removeClass('visible-print');
        }
    });
});